"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.map");

require("core-js/modules/es7.array.includes");

var _classnames = _interopRequireDefault(require("classnames"));

var _HelperText = _interopRequireDefault(require("../HelperText"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var componentsWithErrorProp = ['WithId(Checkbox)', 'WithId(Datepicker)', 'WithId(Input)', 'WithId(Radio)', 'WithId(Select)'];

function shouldPassErrorProp(component) {
  // use render.displayName for components wrapped with forwardRef
  return componentsWithErrorProp.includes(component.type.displayName || component.type.render && component.type.render.displayName);
}

var propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  error: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].node]),
  helper: _propTypes["default"].node,
  legend: _propTypes["default"].node,
  textSize: _propTypes["default"].string
};
var defaultProps = {
  disabled: false,
  error: false,
  textSize: 'normal'
};

var Fieldset = function Fieldset(_ref) {
  var legend = _ref.legend,
      children = _ref.children,
      error = _ref.error,
      helper = _ref.helper,
      className = _ref.className,
      textSize = _ref.textSize,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["legend", "children", "error", "helper", "className", "textSize"]);

  var wrappedChildren = _react["default"].Children.map(children, function (child) {
    if (child.type.name === 'Button') {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "grv-form-field grv-form-field--button"
      }, child);
    }

    if (error && shouldPassErrorProp(child)) {
      return /*#__PURE__*/_react["default"].cloneElement(child, {
        error: true
      });
    }

    return child;
  });

  var classes = (0, _classnames["default"])('grv-fieldset', className, {
    'grv-fieldset--error': error
  });
  var fieldsetLegend = legend || helper || error ? /*#__PURE__*/_react["default"].createElement("legend", {
    className: "grv-fieldset__legend" + (textSize === 'small' ? ' grv-fieldset__legend--small' : '')
  }, legend, /*#__PURE__*/_react["default"].createElement(_HelperText["default"], {
    content: helper,
    type: "legend"
  }), /*#__PURE__*/_react["default"].createElement(_HelperText["default"], {
    error: true,
    content: error,
    type: "legend"
  })) : null;
  return /*#__PURE__*/_react["default"].createElement("fieldset", _extends({}, otherProps, {
    className: classes
  }), fieldsetLegend, wrappedChildren);
};

Fieldset.propTypes = propTypes;
Fieldset.defaultProps = defaultProps;
var _default = Fieldset;
exports["default"] = _default;